import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["factoring.editLineItem"],
  payload => payload
);
